// extracted by mini-css-extract-plugin
module.exports = {"trash":"ClickableCard_trash__Obki3","reload":"ClickableCard_reload__JjL3B"};